import _ from 'underscore';
import Localizer from 'localizer';
import Backbone from 'backbone';
import ConsentText from 'models/gdpr/Consent';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import ModelSynchronizer from 'utils/ModelSynchronizer';
import LocaleMapper from 'utils/LocaleMapper';
import GdprUtil from 'utils/gdpr/GdprUtil';
import templateHtml from 'views/gdpr/templates/gdprModal.html';

export default Backbone.View.extend({
    template: _.template(templateHtml),

    initialize: function(args) {
        this.modalTopTitle = args.modalTopTitle;
        this.grantRevoke = args.grantRevoke;
        this.consentType = args.consentType;
        this.thirdPartyApp = args.thirdPartyApp;
        this.thirdPartyUrl = args.thirdPartyUrl;
        this.customCancelText = args.customCancelText;
        this.footerSecondaryButtonClasses = args.footerSecondaryButtonClasses;
        this.showCloseButton = true;

        if (args.showCloseButton !== undefined) {
            this.showCloseButton = args.showCloseButton;
        }

        this.language = LocaleMapper.getFullLocale(ViewerUserPreferences.get('preferredLocale'));

        this.gdprConsentText = new ConsentText({
            consentTypeId: this.consentType,
            locale: this.language
        });
    },

    render: function() {
        var modelSynchronizer = new ModelSynchronizer();
        modelSynchronizer.addModel({ model: this.gdprConsentText, required: true });
        modelSynchronizer.on(ModelSynchronizer.Events.SYNCHRONIZED, this.getConsentModal, this);
        modelSynchronizer.fetchModels();
    },

    getConsentModal: function() {
        this.consentText = this.gdprConsentText.attributes[0];
        var modalTile,
            modalBody,
            saveBtn,
            cancelBtn,
            footerLink,
            footerTextLink,
            footerPrimaryButtonClasses,
            footerSecondaryButtonClasses;

        if (this.grantRevoke === 'grant') {
            modalTile = this.thirdPartyApp
                ? this.consentText.headline.split('[APP]').join(this.thirdPartyApp)
                : this.consentText.headline;
            modalBody = GdprUtil.getGdprContentText(this.consentText.consentCopyBlocks, this.thirdPartyApp);
            saveBtn = this.consentText.grantButton;
            cancelBtn = this.consentText.rejectButton;
            footerLink = this.thirdPartyUrl
                ? this.thirdPartyUrl
                : this.consentText.revokeLinks.length > 0
                ? this.consentText.revokeLinks[0].url
                : '';
            footerTextLink = this.getFooterTextLink(this.consentText.consentLinks);
            footerPrimaryButtonClasses = '';
            footerSecondaryButtonClasses = this.footerSecondaryButtonClasses ? this.footerSecondaryButtonClasses : '';
        } else if (this.grantRevoke === 'revoke') {
            modalTile = this.thirdPartyApp
                ? this.consentText.revokeHeadline.split('[APP]').join(this.thirdPartyApp)
                : this.consentText.revokeHeadline;
            modalBody = GdprUtil.getGdprContentText(this.consentText.revokeCopyBlocks, this.thirdPartyApp);
            saveBtn = this.consentText.revokeConsentButton;
            cancelBtn = this.consentText.revokeCancelButton;
            footerLink = this.thirdPartyUrl
                ? this.thirdPartyUrl
                : this.consentText.revokeLinks.length > 0
                ? this.consentText.revokeLinks[0].url
                : '';
            footerTextLink = this.getFooterTextLink(this.consentText.revokeLinks);
            footerPrimaryButtonClasses = 'btn-danger';
        }

        this.$el.html(
            this.template({
                Localizer: Localizer,
                modalTopTitle: this.modalTopTitle,
                modalTitle: modalTile,
                modalBody: modalBody,
                saveBtn: saveBtn,
                cancelBtn: this.customCancelText ? this.customCancelText : cancelBtn,
                footerLink: footerLink,
                footerTextLink: footerTextLink,
                footerPrimaryButtonClasses: footerPrimaryButtonClasses,
                footerSecondaryButtonClasses: footerSecondaryButtonClasses,
                showCloseButton: this.showCloseButton
            })
        );
    },

    getFooterTextLink: function(footerTextLink) {
        if (footerTextLink.length) {
            if (this.thirdPartyApp) {
                return footerTextLink[0].text.split('[APP]').join(this.thirdPartyApp);
            } else {
                return footerTextLink[0].text;
            }
        }
        return '';
    },

    getConsentVersion: function() {
        return this.consentText.version;
    }
});
